<ion-toolbar [ngStyle]="{ '--background': bgColor }">
  @if(backButtonRouterLink || backButton) {
    <ion-buttons slot="start">
      <ion-button [routerLink]="backButtonRouterLink ? backButtonRouterLink : '/tabs/customer'"
                  [ngStyle]="{ '--color': color }">
        <i slot="icon-only" class="fa-light fa-arrow-left tk-fa-md"></i>
      </ion-button>
    </ion-buttons>
  }

  @if(withMenuButton) {
    <ion-buttons slot="start">
      <ion-menu-button [ngStyle]="{ '--color': color }"></ion-menu-button>
    </ion-buttons>
  }

  @if(startTemplate) {
    <ng-container [ngTemplateOutlet]="startTemplate"></ng-container>
  }

  @if(title) {
    <ion-title style="font-weight: normal; text-transform: uppercase;"
               [ngStyle]="{ '--color': color, paddingLeft: backButtonRouterLink || backButton || startTemplate || withMenuButton ? 0 : null }">

      @if(isTitleTemplate) {
        <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
      }
      @else {
        {{ title }}
      }
      @if (subtitle) {
       <br /><small>{{ subtitle }}</small>
      }
      @else if (subtitleTemplate) {
        <br /><ng-container [ngTemplateOutlet]="subtitleTemplate"></ng-container>
      }
    </ion-title>
  }

  @if(endTemplate) {
    <ng-container [ngTemplateOutlet]="endTemplate"></ng-container>
  }

  @if(closeable) {
    <ion-buttons slot="end">
      <ion-button [ngStyle]="{ '--color': color }" (click)="closeEvent.emit()">
        <i slot="icon-only" class="fa-light fa-close tk-fa-md"></i>
      </ion-button>
    </ion-buttons>
  }

</ion-toolbar>
